import {
  ActionCenterDetails,
  AdvocateCount,
  Nullable,
  SignupDetails,
} from '@/core/interfaces/common';

import { alternateRequest } from '@/utils/alternateRequest';
import { isValidUrl } from '@/utils/helpers';
import { request } from '@/utils/request';

export const fetchSingupData = async (uuid: string | Array<string> | undefined) => {
  if (isValidUrl(process.env.REACT_APP_ACTION_CENTER_ROOT)) {
    return alternateRequest
      .get<Nullable<SignupDetails>>(`${uuid}.json`)
      .then(({ data }) => data)
      .catch(error => null);
  }

  return request
    .get<Nullable<SignupDetails>>(`/public/signup/${uuid}/`)
    .then(({ data }) => data)
    .catch(error => null);
};

export const fetchActionCenterData = async (uuid: string | Array<string> | undefined) => {
  if (isValidUrl(process.env.REACT_APP_ACTION_CENTER_ROOT)) {
    return alternateRequest
      .get<Nullable<ActionCenterDetails>>(`${uuid}.json`)
      .then(({ data }) => data)
      .catch(error => null);
  }

  return request
    .get<Nullable<ActionCenterDetails>>(`/public/act/${uuid}/`)
    .then(({ data }) => data)
    .catch(error => null);
};

/*
 Returns an object with the count of advocates for an action center.
 */
export const fetchAdvocatesCount = async (uuid: string | Array<string> | undefined) => request
  .get<Nullable<AdvocateCount>>(`/public/act/${uuid}/advocates-count/`)
  .then(({ data }) => data)
  .catch(error => null);
